import Team from "../../../model2/team/team"
import {ModelInterface} from "../../../data-structures/collection"
import {ProjectAccess} from "../../../gd/const/project"

export class TeamToAdd implements ModelInterface {

    public id               : ID
    public team             : Team
    public isSelected       : boolean = false

    public workspaceAccess? : ProjectAccess
    public projectAccess?   : ProjectAccess

    constructor(team: Team) {
        this.id             = team.id
        this.team           = team
    }

    toggleIsSelected():void {
        this.isSelected = !this.isSelected
    }

    unselect(): void {
        this.isSelected = false
    }

    toJSON():JSONObject {
        return {
            id              : this.id,
            isSelected      : this.isSelected,
            workspaceAccess : this.workspaceAccess,
            projectAccess   : this.projectAccess,
        }
    }
} 